import style from "./styles/TotalExpensesCard.module.css";
import {CreditCardOutlined, WalletOutlined} from "@ant-design/icons";
import React from "react";

const ExpensesType = ({cash, non_cash}) => {
    return (
        <div className={style.cardFooter}>
            <div className={style.paymentBreakdown}>
                <div className={style.paymentItem}>
                    <WalletOutlined className={style.cashIcon}/>
                    <span className={style.paymentLabel}>Наличные:</span>
                    <span className={style.paymentValue}>
                            {cash}
                        </span>
                </div>
                <div className={style.paymentItem}>
                    <CreditCardOutlined className={style.nonCashIcon}/>
                    <span className={style.paymentLabel}>Безналичные:</span>
                    <span className={style.paymentValue}>
                            {non_cash}
                        </span>
                </div>
            </div>
        </div>
    )
}

export default ExpensesType;